import * as React from 'react';
import {ReactNode} from 'react';

import {compose} from 'recompose';
import {Link, Switch, Route, withRouter} from 'react-router-dom';

import {Row, Col, Icon, Layout, Menu} from 'antd';

import Firebase, {withFirebase} from '../../components/Firebase';

import Courses from '../../containers/Courses/Courses';
import Course from '../../containers/Course/Course';
import Chat from '../../containers/Chat/Chat';
import HeaderUser from '../../components/HeaderUser/HeaderUser';
import NurateFeedback from '../../components/NurateFeedback/NurateFeedback';

import logo from '../../images/nurate-logo-white.png';

import './Main.css';
import FeedbackForm from '../../containers/Course/FeedbackForm';
import FormModal from '../../components/FormModal/FormModal';


interface IProps {
  firebase: Firebase;
  match: any;
  history: any;
  children?: ReactNode;
}

const { Header, Sider, Content } = Layout;

const Main = (props: IProps) => {
  const {match, history} = props;
  const path = window.location.pathname;

  let selectedSidebarKey: string;
  if (path.includes('courses')) {
    selectedSidebarKey = 'courses';
  } else if (path.includes('professors')) {
    selectedSidebarKey = 'professors';
  } else if (path.includes('chats')) {
    selectedSidebarKey = 'chats';
  } else {
    selectedSidebarKey = 'none';
  }

  const signOut = (event: any) => {
    event.preventDefault();

    props.firebase.signOut().then(() => {
      // Sign-out successful.
      history.push('/');
    }).catch((error) => {
      // An error happened.
    });

  };

  return(
    <Layout style={{minHeight: window.innerHeight}}>
      <Header className='header' style={{ position: 'fixed', zIndex: 1, width: '100%', padding: '0' }}>
        <Row type='flex' justify='center'>
          <Col span={24} xxl={20} xl={22} md={24}>
            <img src={logo} style={{marginLeft: '5px', height: '24px'}} />
            <a href="#" onClick={signOut}>Logout</a>
            <HeaderUser />
          </Col>
        </Row>
      </Header>

      <Row type='flex' justify='center'>
        <Col span={24} xxl={20} xl={22} md={24}>
          <Layout style={{ padding: '0 0', marginTop: 42}}>
              <Sider width={180}
                     breakpoint="md"
                     collapsedWidth="0" style={{background: 'transparent'}}>
                <Menu
                  mode="inline"
                  selectedKeys={[selectedSidebarKey]}
                  style={{ borderRight: 0,  background: 'transparent'}}
                >
                  <Menu.Item key="courses">
                    <Link to='/courses' >
                      <Icon type='book'/>
                      <span className="nav-text">
                        Courses
                      </span>
                    </Link>
                  </Menu.Item>
                </Menu>
              </Sider>
              <Layout style={{ paddingLeft: '24px', paddingBottom: '70px' }}>
                <Content>
                  <Switch>
                    <Route path={`${match.url}courses/:courseSlug/chat`} component={Chat} />
                    <Route path={`${match.url}courses/:courseSlug`} component={Course} />
                    <Route path={`${match.url}courses`} component={Courses} />
                  </Switch>
                  <div style={{position: 'fixed', bottom: 10, right: 20}}>
                    <h4>Found BUG? or want to leave feedback about nurate?</h4>
                    <FormModal buttonText='Write us'
                               formComponent={<NurateFeedback />}
                    />
                  </div>
                </Content>
              </Layout>
            </Layout>
        </Col>
      </Row>
    </Layout>
  )
};

export default compose(
  withRouter,
  withFirebase
)(Main);
